<template>
<div class="chapter">
<div class="inner_page">
<div class="bodyMatter">
<div class="chapter" id="ch01">
<div class="chapterHead">
<h2 class="chapterTitle2"><span class="xrefInternal"><a href="#/contents#ch_01"><span class="bold">J<span class="smallCaps">ANE</span> A<span class="smallCaps">LEXANDER</span></span></a></span><span class="footnoteRef"><span href="#/footnote#footnote1" id="fn1" title="Link target outside of Sample"><sup>*</sup></span></span></h2></div>
<div class="chapterBody">
<p class="chapterOpenerText">W<span class="smallCaps">HEN</span> I <span class="smallCaps">FIRST HEARD</span> “I<span class="smallCaps">MAGINE,” AND THE SOFT, GENTLE VOICE OF</span> J<span class="smallCaps">OHN SINGING,</span> I <span class="smallCaps">WAS QUITE OVERWHELMED.</span> T<span class="smallCaps">HE SONG SEEMED TO ENCAPSULATE ALL WE IN THE 1960S DREAMED OF: A WORLD WITH NO VIOLENCE, NO RACISM, NO</span> war, no assassinations—a world possible through envisioning it to be so. I still believe it, and every time I hear the song, it enforces my belief. We can have peace, harmony, beauty and love if we make that our constant vision for the future, if we imagine it and live it ourselves every day. That was John’s gift to us, all through his remarkable song.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?28ccface